import { render, staticRenderFns } from "./QuestionsTypeDelete.vue?vue&type=template&id=1299bbfe&scoped=true&"
import script from "./QuestionsTypeDelete.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299bbfe",
  null
  
)

export default component.exports